export default "__VITE_ASSET__BJzkp0uO__"